// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found[data-v-7e8916e0] {
  padding: 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfCamSelect.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","sourcesContent":[".not-found[data-v-7e8916e0] {\n  padding: 5px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
